module.exports = __webpack_public_path__ + "static/media/seat-sling.177e6507.svg";